$(document).ready(function() {
    $(window).scroll(function() {
    
    var scrollDistance = $(window).scrollTop();

    
    var header = $('#header');
    if (scrollDistance >= 20) {
      header.addClass('show');
    } else {
      header.removeClass('show');
    }
  });

});